// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1avfy","tab":"Tabs_tab__1I_Me","tabActive":"Tabs_tabActive__3JC04"};